export function foregroundMajorityOfBox(frames, sourceWidth, firstI, endI, firstJ, endJ, labels, counts) {
    let majority = 0;
    let majorityCount = 0;
    labels.length = 0;
    counts.length = 0;
    for (const frame of frames) {
        for (let j = firstJ; j < endJ; j++) {
            const row = j * sourceWidth;
            for (let i = firstI; i < endI; i++) {
                const label = frame[row + i];
                if (label === 0) {
                    continue;
                }
                let slot = labels.indexOf(label);
                if (slot === -1) {
                    slot = labels.length;
                    labels.push(label);
                    counts.push(0);
                }
                const count = ++counts[slot];
                if (count > majorityCount) {
                    majorityCount = count;
                    majority = label;
                }
            }
        }
    }
    return majority;
}
export default function fillPlaneByForegroundMajority(frames, [sourceWidth, sourceHeight], [width, height], [factorI, factorJ], values) {
    const labels = [];
    const counts = [];
    for (let targetJ = 0; targetJ < height; targetJ++) {
        const firstJ = targetJ * factorJ;
        const endJ = targetJ === height - 1
            ? sourceHeight
            : Math.min(firstJ + factorJ, sourceHeight);
        for (let targetI = 0; targetI < width; targetI++) {
            const firstI = targetI * factorI;
            const endI = targetI === width - 1
                ? sourceWidth
                : Math.min(firstI + factorI, sourceWidth);
            values[targetJ * width + targetI] = foregroundMajorityOfBox(frames, sourceWidth, firstI, endI, firstJ, endJ, labels, counts);
        }
    }
}
